import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class PacksSlider {
	constructor($el) {
		this.$el = $el;
        this.$wrapper = this.$el.parent();
        this.$buttons = this.$wrapper.find('.slider__button');
        this.$btns = this.$wrapper.find('.slider__buttons-wrapper');
        // this.$buttons.classList.add("hidden"); Masquer le boutons si aucun carrousel

		this.options = {
			// autoPlay: true,
			pageDots: false,
			wrapAround: false,
            contain: true,
			prevNextButtons: false,
			freeScroll: true,
			cellSelector: ".pack",
            cellAlign: "left",
		};

		if (this.$el.length) {
			this._init();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.pack');
        this.slidesCount = this.$slides.length;

        // console.log('Nombre de slides PACKS: ' + this.slidesCount);

        if (document.body.clientWidth < 620 && this.slidesCount > 1) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Packs - slider mobile');
        } else if (document.body.clientWidth >= 620 && document.body.clientWidth < 800 && this.slidesCount > 2) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Packs - slider tablet');
        } else if (document.body.clientWidth >= 800 && document.body.clientWidth < 1024 && this.slidesCount > 3) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Packs - slider desktop SM');
        } else if (document.body.clientWidth >= 1024 && document.body.clientWidth < 1202 && this.slidesCount > 4) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Packs - slider desktop MD');
        } else if (document.body.clientWidth >= 1202 && document.body.clientWidth < 1645 && this.slidesCount > 5) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Packs - slider desktop LG');
        } else if (document.body.clientWidth >= 1645 && this.slidesCount > 6) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Packs - slider desktop XL');
        } else {
            // console.log('Packs - no packs slider');
            this.$btns[0].classList.add("hidden");
        } 
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);

        this.$buttons.on('click', this._onButtonClick.bind(this));
    }

    _onButtonClick(e) {
        const $target = $(e.currentTarget);

        if($target.hasClass('slider__button--previous')) {
            this.slider.previous(true);
            // console.log('précédent');
        }
        else if($target.hasClass('slider__button--next')) {
            this.slider.next(true);
            // console.log('suivant');
        }
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

	_onBreakpointChange() {
        if (document.body.clientWidth < 620 && this.slidesCount > 1) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            this.$btns[0].classList.remove("hidden");
            // console.log('slider resize mobile');
        } else if (document.body.clientWidth >= 620 && document.body.clientWidth < 800 && this.slidesCount > 2) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            this.$btns[0].classList.remove("hidden");
            // console.log('slider resize tablet');
        } else if (document.body.clientWidth >= 800 && this.slidesCount > 3) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            this.$btns[0].classList.remove("hidden");
            // console.log('slider resize desktop SM');
        } else if (document.body.clientWidth >= 1024&& document.body.clientWidth < 1202 && this.slidesCount > 4) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            this.$btns[0].classList.remove("hidden");
            // console.log('slider resize desktop MD');
        } else if (document.body.clientWidth >= 1202 && document.body.clientWidth < 1645 && this.slidesCount > 5) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            this.$btns[0].classList.remove("hidden");
            // console.log('slider resize desktop LG');
        } else if (document.body.clientWidth >= 1645 && this.slidesCount > 6) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            this.$btns[0].classList.remove("hidden");
            // console.log('slider resize desktop XL');
        } else {
            this._destroy();
            // console.log('Packs - no packs slider');
            this.$btns[0].classList.add("hidden");
        }
    }

    // flkty.previous( true )
}

export default PacksSlider;
